import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PanelCardView } from '../enums/panelCardView';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class PanelListPersistenceService {
  panelListView$ = new BehaviorSubject<number>(PanelCardView.DefaultView);
  assignmentiewMenuItem !:MenuItem
  defaultView !: MenuItem

  constructor() { }
  updatePanelListView(panelListView : number){
    this.panelListView$.next(panelListView);
}
}
